import { configureStore } from '@reduxjs/toolkit'

import auth from 'store/auth/auth'
import countrySelected from 'store/global/countrySelected'
import sectionSelected from 'store/global/sectionSelected'
import companyState from 'store/global/userCompany'
import layersInfo from 'store/global/map/layersInfo'
import filesMenuInfo from 'store/global/map/filesMenuInfo'
import deckglLayersInfo from 'store/global/map/deckglLayersInfo'
import sideBarInfo from 'store/global/map/sideBarInfo'
import finderInfo from 'store/global/map/finderInfo'
import viewState from 'store/global/map/viewState'
import basemapStyle from 'store/global/map/basemapStyleInfo'

export default configureStore({
  reducer: {
    auth,
    countrySelected,
    sectionSelected,
    layersInfo,
    filesMenuInfo,
    deckglLayersInfo,
    sideBarInfo,
    finderInfo,
    viewState,
    companyState,
    basemapStyle,
  },
})
